import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PageSettings } from './../../config/page-settings.js';
import Services from '../../services/service';
import artajasa from '../_layoutPublicWebVisitor/preview-template/artajasa.png';

const qrImgStyle = {
  width: '200px',
  height: '200px',
  alignSelf: 'center'
};

class FormVisitor extends Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);
    this.state = {
      formTitle: '',
      publicWebData: [],
      submittedDisclaimer: [],
      submittedComponent: [],
      totalDisclaimerValue: 0,
      formVisitorSubmitted: false,
      visitorType: '',
      userName: '',
      imgData: ''
    };
  }

  componentDidMount() {
    const { visitorType, userName } = this.props.history.location.state;
    this.getPublicWebPage();
    this.setState({ visitorType: visitorType, userName: userName });
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(true);
    this.context.handleSetPageContentClass('p-0');
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetPageContentClass('');
    this.context.handleSetBodyWhiteBg(false);
  }

  removeDuplicateDisclaimerData = (submittedDisclaimer, disclaimer) => {
    submittedDisclaimer.map(item => {
      if(item.disclaimer === disclaimer.disclaimer) {
        const index = submittedDisclaimer.indexOf(item);
        submittedDisclaimer.splice(index, 1)
      }
      return submittedDisclaimer;
    });
  };

  handleFieldChange = () => (e) => {
    const { submittedComponent } = this.state;
    const component = {
      label: e.target.dataset.label,
      value: e.target.value
    };
    submittedComponent.map(componentItem => {
      if(componentItem.label === component.label) {
        const indexComponent = submittedComponent.indexOf(componentItem);
        submittedComponent.splice(indexComponent, 1)
      }
      return submittedComponent;
    });
    submittedComponent.push(component);
    this.setState({ submittedComponent: submittedComponent })
  };

  handleCheckBox = () => (e) => {
    const checklistValue = e.target.dataset.value;
    const disclaimerLabel = e.target.dataset.label;
    const checked = e.target.checked;
    const { submittedDisclaimer } = this.state;
    if(e.target.checked) {
      const totalValue = parseInt(this.state.totalDisclaimerValue) + parseInt(checklistValue);
      const newDisclaimer = {
        disclaimer: disclaimerLabel,
        checked: checked
      };
      this.removeDuplicateDisclaimerData(submittedDisclaimer, newDisclaimer);
      submittedDisclaimer.push(newDisclaimer);
      this.setState({totalDisclaimerValue: totalValue, submittedDisclaimer});
    } else {
      const totalValue = parseInt(this.state.totalDisclaimerValue) - parseInt(checklistValue);
      const disclaimer = {
        disclaimer: disclaimerLabel,
        checked: checked
      };
      this.removeDuplicateDisclaimerData(submittedDisclaimer, disclaimer)
      submittedDisclaimer.push(disclaimer);
      this.setState({totalDisclaimerValue: totalValue, submittedDisclaimer});
    }
  };

  handleSubmit = () => {
    const { submittedComponent, submittedDisclaimer, totalDisclaimerValue } = this.state;
    const payload = {
      visitorType: this.props.location.state.visitorType,
      employeeId: '',
      componentData: submittedComponent,
      disclaimerData: submittedDisclaimer,
      calculateValue: totalDisclaimerValue
    }
    Services.postVisitorForm(payload)
      .then( res => {
        const qrPayload = {
          type: 'visitor-set',
          id: res.data
        }
        this.getQrCode(qrPayload);
        this.setState({ formVisitorSubmitted: true })
      })
      .catch(err => console.log(err))
  };

  getQrCode = (qrData) => {
    Services.getQRCode(qrData)
      .then( respond => {
        this.setState({ imgData: respond.file })
      })
      .catch(err => console.log(err))
  }

  getPublicWebPage = () => {
    Services.getPublicWebPage()
      .then(res => {
        this.setState({ publicWebData: res })
      })
      .catch(err => console.log(err))
  };

  render() {
    const { publicWebData: { title, desc, componentData, disclaimerData}, formVisitorSubmitted, visitorType } = this.state;

    const disabled = this.state.totalDisclaimerValue <= 0;
    let formComponent = '';
    let disclaimerComponent = '';
    if(visitorType === '1'){
      if(componentData) {
        formComponent = componentData.map(item =>
          <div key={item._id} style={{width: '50%'}}>
            <div className="desc">
              <div className="form-group row">
                <label className="col-sm-4">{item.label}</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    data-label={item.label}
                    onChange={this.handleFieldChange()}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
    } else {
      formComponent = (
        <div className="form-group row">
          <h5 className="col-sm-12">Selamat datang, {this.state.userName}</h5>
          <label className="col-sm-12" style={{marginTop: '10px'}}>Mohon lengkapi pernyataan di bawah ini: </label>
        </div>
      )
    }
    if(disclaimerData) {
      disclaimerComponent = disclaimerData.map(item =>
        <div key={item._id} style={{marginTop: '15px'}}>
          <div className="desc">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                data-value={item.value}
                data-label={item.disclaimer}
                onChange={this.handleCheckBox()}
              />
              <label className="form-check-label">{item.disclaimer}</label>
            </div>
          </div>
        </div>
      )
    }
    return(
      <form
        onSubmit={e => {
          e.preventDefault();
          this.handleSubmit()
        }}
      >
        <div className="coming-soon">
          <div className="coming-soon-header" style={{background: 'none', padding: '25px 50px 50px'}}>
            <div className="bg-cover"/>
            <div className="brand" style={{ textAlign: 'end' }}>
              <img
                style={{ width:'6%', height:'6%' }}
                src={artajasa}
              />
            </div>
            <div className="brand">
              {formVisitorSubmitted ? 'Terima Kasih Atas Kunjungan Anda' : title}
            </div>
            <div className="desc">
              {formVisitorSubmitted ? 'Download dan Perlihatkan QR Code Dibawah Kepada Petugas' : desc}
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center" style={{padding: '50px'}}>
            {formVisitorSubmitted ? '' : formComponent}
            {formVisitorSubmitted ? '' : disclaimerComponent}
            {!formVisitorSubmitted &&
              <div className="d-flex justify-content-around align-self-center" style={{width: "20%", marginTop: 20}}>
                <button disabled={disabled} type="submit" className="btn btn-success">Submit</button>
              </div>
            }
            {formVisitorSubmitted &&
              <img src={`data:${this.state.imgData}`} alt="QR Image" style={qrImgStyle}/>
            }
            {formVisitorSubmitted &&
              <div className="d-flex justify-content-around align-self-center" style={{width: "20%", marginTop: 20}}>
                <a download="qr.jpg" href={`data:${this.state.imgData}`}>
                  <button type="button" className="btn btn-success">Download</button>
                </a>
              </div>
            }
          </div>
        </div>
      </form>
    )
  }
}

export default withRouter(FormVisitor)
